import React from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

import Cart from 'surface_mount_carriers/components/Cart';
import { changeParameter, validator, updateQuantity, updateValidatorFlag } from 'selective_solder_fixtures/store/slice';
import { selectDataForCart } from 'selective_solder_fixtures/store/selectors';
import { addToCart } from 'selective_solder_fixtures/store/thunks';

export default () => {
  const dispatch = useDispatch();

  const {
    quantity,
    parameters,
    quote,
    addingToCart,
  } = useSelector(selectDataForCart);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
  };

  const onChangeQuantity = (value) => {
    dispatch(updateQuantity(value));
    onChangeParameter('quantities', [value]);
  };


  const onAddToCart = async () => {
    try {
      if (validator.allValid()) {
        await dispatch(addToCart()).unwrap();

        // eslint-disable-next-line no-undef
        window.location.href = '/cart';
      } else {
        validator.showMessages();
        dispatch(updateValidatorFlag());
        toast(Spree.translations.project_errors, { type: 'error' });
      }
    } catch (e) {
      toast(Spree.translations.add_to_cart_error, { type: 'error' });
    }
  };


  return (
    <Cart
      parameters={parameters}
      quote={quote}
      quantity={quantity}
      onChangeParameter={onChangeParameter}
      onChangeQuantity={onChangeQuantity}
      onAddToCart={onAddToCart}
      addingToCart={addingToCart} />
  );
};
